(() => {
  const bar = document.querySelector('[data-tdc-sticky-atc]');
  if (!bar) return;

  const mainButton = document.querySelector('[id^="ProductSubmitButton-"]');
  const mainForm = mainButton?.closest('form[action*="/cart/add"]');
  const stickyButton = bar.querySelector('[data-tdc-button]');
  const stickyPrice = bar.querySelector('[data-tdc-price]');
  const priceContainer = document.querySelector('[id^="price-"]');

  if (!mainButton || !mainForm || !stickyButton) return;

  const sync = () => {
    stickyButton.disabled = mainButton.disabled;
    const label = stickyButton.querySelector('span');
    if (label) {
      label.textContent = mainButton.disabled
        ? stickyButton.dataset.tdcSoldOutLabel
        : stickyButton.dataset.tdcAvailableLabel;
    }
    const mainPrice = priceContainer?.querySelector('.price');
    if (mainPrice && stickyPrice) {
      const currentPrice = mainPrice.classList.contains('price--on-sale')
        ? mainPrice.querySelector('.price__sale .price-item--sale')
        : mainPrice.querySelector('.price__regular .price-item--regular');
      if (currentPrice) stickyPrice.textContent = currentPrice.textContent.trim();
    }
  };

  const setVisibility = () => {
    const rect = mainButton.getBoundingClientRect();
    const visible = matchMedia('(max-width: 749px)').matches && (rect.top > innerHeight - 96 || rect.bottom < 96);
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('tdc-sticky-visible', visible);
  };

  stickyButton.addEventListener('click', () => {
    if (!mainButton.disabled) mainButton.click();
  });
  new MutationObserver(sync).observe(mainButton, { attributes: true, childList: true, subtree: true });
  document.addEventListener('change', () => setTimeout(sync, 0));
  if (priceContainer) new MutationObserver(sync).observe(priceContainer, { childList: true, subtree: true });
  addEventListener('scroll', setVisibility, { passive: true });
  addEventListener('resize', setVisibility, { passive: true });
  sync();
  setVisibility();
})();